import { render, staticRenderFns } from "./manage-paper.vue?vue&type=template&id=7ce9d67e&scoped=true"
import script from "./manage-paper.vue?vue&type=script&lang=js"
export * from "./manage-paper.vue?vue&type=script&lang=js"
import style0 from "./manage-paper.vue?vue&type=style&index=0&id=7ce9d67e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9d67e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce9d67e')) {
      api.createRecord('7ce9d67e', component.options)
    } else {
      api.reload('7ce9d67e', component.options)
    }
    module.hot.accept("./manage-paper.vue?vue&type=template&id=7ce9d67e&scoped=true", function () {
      api.rerender('7ce9d67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/manage-paper.vue"
export default component.exports